module.exports = __webpack_public_path__ + "font/7253f0882aea10e73ac34e95550d2765.ttf";